/**
 * React Router passes `state` to the History API (`pushState` / `replaceState`), which uses
 * the structured clone algorithm. React Navigation route params sometimes include functions
 * (for example ad-hoc function values in route state), which trigger
 * `DataCloneError` if passed through unchanged.
 *
 * JSON round-tripping yields a plain, JSON-serializable snapshot safe for history state.
 *
 * **JSON.stringify and functions:** On plain objects, a property whose value is a function is
 * omitted entirely. In arrays, a function element becomes `null` (e.g. `[1, fn, 3]` →
 * `[1, null, 3]`). Route params are almost always plain objects, so the array case is rare;
 * it is documented here so callers do not have to rediscover it.
 */
export function serializeWebHistoryState(state: unknown): unknown {
  if (state === undefined || state === null) {
    return undefined;
  }
  if (typeof state !== 'object') {
    return state;
  }
  try {
    return JSON.parse(JSON.stringify(state)) as unknown;
  } catch {
    return undefined;
  }
}
